export default () => ({
  show: false,
  isLoading: true,
  onCancel: false,
  fullPage: true,
  visitor: {
    name: null,
    country_register: null,
    image_id: null,
    type: 'guest',
    status: 'true',
    company: null
  },
  visitors: [],
  entity: 'visitor',
  entities: 'visitors',
  optionStatus: [
    {
      id: 'true',
      label: 'Ativo'
    },
    {
      id: 'false',
      label: 'Inativo'
    }
  ],
  optionType: [
    {
      id: 'guest',
      label: 'Visitante'
    },
    {
      id: 'provider',
      label: 'Prestador Serviço'
    },
    {
      id: 'others',
      label: 'Outros'
    }
  ],
  prefixRouter: 'concierge.visitor'
})



// WEBPACK FOOTER //
// ./src/app/dweller/visitor/resources/data.js